
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Search, Home } from "lucide-react";

const ProductNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="text-center space-y-6">
        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-gray-900">Product Not Found</h1>
          <p className="text-gray-600 max-w-md mx-auto">
            The product you're looking for doesn't exist or may have been removed.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
          <Button onClick={() => navigate('/products')} className="flex items-center gap-2">
            <ArrowLeft className="h-4 w-4" />
            Browse Products
          </Button>
          
          <Button variant="outline" onClick={() => navigate('/')} className="flex items-center gap-2">
            <Home className="h-4 w-4" />
            Go Home
          </Button>
        </div>

        <div className="mt-8 p-4 bg-gray-50 rounded-lg">
          <p className="text-sm text-gray-500">
            Having trouble finding what you're looking for? Try searching or browsing our categories.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProductNotFound;
